import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import React from "react";
import loader, { PageResourceStatus } from "./loader";
import shallowCompare from "shallow-compare";

var EnsureResources = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(EnsureResources, _React$Component);

  function EnsureResources(props) {
    var _this;

    _this = _React$Component.call(this) || this;
    var location = props.location,
        pageResources = props.pageResources;
    _this.state = {
      location: Object.assign({}, location),
      pageResources: pageResources || loader.loadPageSync(location.pathname)
    };
    return _this;
  }

  EnsureResources.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var location = _ref.location;

    if (prevState.location.href !== location.href) {
      var pageResources = loader.loadPageSync(location.pathname);
      return {
        pageResources: pageResources,
        location: Object.assign({}, location)
      };
    }

    return {
      location: Object.assign({}, location)
    };
  };

  var _proto = EnsureResources.prototype;

  _proto.loadResources = function loadResources(rawPath) {
    var _this2 = this;

    loader.loadPage(rawPath).then(function (pageResources) {
      if (pageResources && pageResources.status !== PageResourceStatus.Error) {
        _this2.setState({
          location: Object.assign({}, window.location),
          pageResources: pageResources
        });
      } else {
        window.history.replaceState({}, "", location.href);
        window.location = rawPath;
      }
    });
  };

  _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
    // Always return false if we're missing resources.
    if (!nextState.pageResources) {
      this.loadResources(nextProps.location.pathname);
      return false;
    } // Check if the component or json have changed.


    if (this.state.pageResources !== nextState.pageResources) {
      return true;
    }

    if (this.state.pageResources.component !== nextState.pageResources.component) {
      return true;
    }

    if (this.state.pageResources.json !== nextState.pageResources.json) {
      return true;
    } // Check if location has changed on a page using internal routing
    // via matchPath configuration.


    if (this.state.location.key !== nextState.location.key && nextState.pageResources.page && (nextState.pageResources.page.matchPath || nextState.pageResources.page.path)) {
      return true;
    }

    return shallowCompare(this, nextProps, nextState);
  };

  _proto.render = function render() {
    if (process.env.NODE_ENV !== "production" && !this.state.pageResources) {
      throw new Error("EnsureResources was not able to find resources for path: \"" + this.props.location.pathname + "\"\nThis typically means that an issue occurred building components for that path.\nRun `gatsby clean` to remove any cached elements.");
    }

    return this.props.children(this.state);
  };

  return EnsureResources;
}(React.Component);

export default EnsureResources;